import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

// material-ui

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";

// core components
import CardTable from "components/CardTable/CardTable";

// config Table
import { configTable } from "./tableData";

import {
  setConfigBrandsSalesFilter,
  setConfigBrandsSalesPage,
  setConfigBrandsSalesPageSize,
  setConfigBrandsSalesSorted,
} from "redux/ducks/brandsSection";
import { convertToMapById } from "helpers/convertToMap";
import { validateObject } from "helpers/validateObject";

const BrandSales = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const { page, pageSize, sorted } = useSelector(
    (state) => state.brandsSection.config.brandsSales
  );
  const { brandSales, brandName, station} = useSelector(state => state.brandsReducer)
  const { stations } = useSelector(state => state.companies)

  const [mapBrandSales, setMapBrandSales] = useState([])
  const [filterBrands, setFilterBrands] = useState([])

  useEffect(() => {
    setMapBrandSales( convertToMapById(brandSales) )
  }, [ brandSales, brandName ])
  
  useEffect(() => {
    if(validateObject(station) && mapBrandSales.length > 0) {
      setFilterBrands( mapBrandSales.filter(brand => brand.idStation === station.id).map(brandM => {
        return {
          ...brandM,
          stationName: stations[brandM.idStation].label
        }
      }) )
    } else if(mapBrandSales.length > 0){
      setFilterBrands( mapBrandSales.map(brandM => {
        return {
          ...brandM,
          stationName: stations[brandM.idStation]?.label
        }
      }) )
    }
    
  }, [station, mapBrandSales, brandSales, brandName, stations])

  const handleChangePage = (page) => {
    const newDirection = page ? page : "/admin/nuevo_marca_venta";
    history.push(newDirection);
  };

  // calls
  const handleChangeBrandsSalesFilteredMemoized = useCallback(
    (event) => {
      dispatch(setConfigBrandsSalesFilter(event));
    },
    [dispatch]
  );
  const handleChangeBrandsSalesPageMemoized = useCallback(
    (event) => {
      dispatch(setConfigBrandsSalesPage(event));
    },
    [dispatch]
  );
  const handleChangeBrandsSalesPageSizeMemoized = useCallback(
    (event) => {
      dispatch(setConfigBrandsSalesPageSize(event));
    },
    [dispatch]
  );
  const handleChangeBrandsSalesSortedMemoized = useCallback(
    (event) => {
      dispatch(setConfigBrandsSalesSorted(event));
    },
    [dispatch]
  );

  return (
    <CardTable
      hasHeader
      title="Marcas ventas"
      icon={<Assignment />}
      data={filterBrands}
      page={page}
      sorted={sorted}
      pageSize={pageSize}
      onChangePage={handleChangePage}
      columns={configTable}
      previousText="Anterior"
      nextText="Siguiente"
      noDataText="Sin datos"
      pageText="Pagina"
      ofText="de"
      resizable={false}
      rowsText="marcas"
      onPageChange={handleChangeBrandsSalesPageMemoized}
      onPageSizeChange={handleChangeBrandsSalesPageSizeMemoized}
      onSortedChange={handleChangeBrandsSalesSortedMemoized}
      onFilteredChange={handleChangeBrandsSalesFilteredMemoized}
    />
  );
};

export default BrandSales;
